import { Action, Reducer } from "redux";
import { QuoteImportStatusState, QuoteImportStatusTypes, QuoteImportStatusActionTypes } from "./quoteImportStatusTypes";

export const INITIAL_STATE: QuoteImportStatusState = {
	quoteImportStatus: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const quoteImportStatusReducer: Reducer<QuoteImportStatusState> = (
	state: QuoteImportStatusState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as QuoteImportStatusActionTypes;
	switch (actionTypes.type) {
		case QuoteImportStatusTypes.GET_QUOTE_IMPORT_STATUS:
			return {
				...state,
				quoteImportStatus: { ...state.quoteImportStatus, isLoading: true },
			};
		case QuoteImportStatusTypes.SAVE_QUOTE_IMPORT_STATUS:
			return {
				...state,
				quoteImportStatus: {
					...state.quoteImportStatus,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case QuoteImportStatusTypes.RESET_REDUCER_QUOTE_IMPORT_STATUS:
			return {
				...state,
				quoteImportStatus: INITIAL_STATE.quoteImportStatus,
			};
		default:
			return state;
	}
};

export default quoteImportStatusReducer;
